<script setup>
  import {ref} from "vue";

  import ComponentDialog from "@components/Dialogs/Dialog.vue";
  import ComponentCommentList from "@components/Lists/CommentList.vue";

  defineOptions({
    name: "ComponentCommentsDialog",
  });

  defineProps({
    patientId: {
      type: String,
      required: true,
    },
    recordId: {
      type: String,
      required: true,
    },
    confidential: {
      type: Boolean,
      default: false,
    },
    comments: {
      type: Array,
      default: () => {
        return [];
      },
    },
  });

  const refDialog = ref(null);

  function open() {
    refDialog.value.open();
  }

  defineExpose({
    open,
  });
</script>

<template>
  <ComponentDialog
    ref="refDialog"
    dialog-type="information"
    :dialog-title="confidential ? 'Rückmeldungen des Arztes' : 'Chat (Fallfreigabe)'"
    dialog-width="medium"
    primary-label="Schließen"
    :test-id="getTestId('comments')"
  >
    <template #content>
      <p v-if="confidential">
        Kommentare von externen Ärzten können nicht direkt von Ihnen beantwortet werden. Bei erneuten Rückfragen
        kommunizieren Sie bitte direkt mit dem jeweiligen Arzt.
      </p>

      <p v-else>
        Kommentare sind für diejenigen MediCheck-Nutzer sichtbar, die Zugriff auf diese Variante besitzen. Das können
        Kollegen sein, die mit Ihnen den MediCheck nutzen oder Personen, denen Sie diese Variante freigebeben haben.
        <br />
        Hinweis: Kommentare gehen nicht in die Arzt- oder Patientenkommunikation ein.
      </p>

      <ComponentCommentList
        class="my-8"
        :patient-id="patientId"
        :record-id="recordId"
        :comments="comments"
        :test-id="getTestId('comments-dialog')"
      />
    </template>
  </ComponentDialog>
</template>
